export const ApplicationProcessStatusTranslations: { [key: string]: string } = {
	Started: "In Prüfung",
	Failed: "Fehlgeschlagen",
	Finished: "Aktiv",
};
